<template>
  <div v-if="importedValue !== null || overrideValue !== null" class="mid-metric-cell">
    <div class="mid-metric-cell__value">
      {{ formatNumber(importedValue) }}
    </div>
    <rmr-status-chip
      v-if="monthLabel"
      :label="monthLabel"
      variant="primary"
      size="sm"
      class="mid-metric-cell__chip"
    />
    <rmr-status-chip
      v-if="overrideValue !== null"
      :label="'Manuel · ' + formatMetricDisplay(overrideValue)"
      variant="success"
      size="sm"
    />
  </div>
  <span v-else class="mid-metric-cell__empty">—</span>
</template>

<script>
import RmrStatusChip from "@/components/ui/feedback/RmrStatusChip.vue";

export default {
  name: "ImportedDataMetricCell",
  components: {
    RmrStatusChip,
  },
  props: {
    importedValue: {
      type: [Number, String, null],
      default: null,
    },
    overrideValue: {
      type: [Number, String, null],
      default: null,
    },
    monthLabel: {
      type: String,
      default: "",
    },
    formatNumber: {
      type: Function,
      required: true,
    },
    formatMetricDisplay: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style scoped>
.mid-metric-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  min-width: 0;
}

.mid-metric-cell__value {
  font-size: 0.84rem;
  font-weight: 700;
  line-height: 1.2;
  color: #111827;
  font-variant-numeric: tabular-nums;
}

.mid-metric-cell__chip {
  width: fit-content;
  max-width: 100%;
}

.mid-metric-cell__empty {
  color: #94a3b8;
  font-size: 0.82rem;
}
</style>
